/**
 * Id of the toast that explains an automatic logout.
 *
 * Fixed rather than derived from the message, because it has to be dismissable from
 * elsewhere: the toast outlives the logout on purpose — the user is usually away from
 * the keyboard when it appears — but it becomes wrong the moment they sign back in.
 */
export const SESSION_EXPIRED_TOAST_ID = 'auth-session-expired';
